var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "453px",
    height: "168px",
    viewBox: "0 0 453 168",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "404") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Specialty-Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "404-Error---Simple",
    transform: "translate(-734.000000, -363.000000)",
    fill: "#E9E9F2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(725.000000, 314.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.06249136,187.000024 L9.06249136,153.250056 L73.43743,52.0001526 L128.437378,52.0001526 L128.437378,153.250056 L146.87486,153.250056 L146.87486,187.000024 L128.437378,187.000024 L128.437378,212 L86.8749171,212 L86.8749171,187.000024 L9.06249136,187.000024 Z M87.8124163,153.250056 L87.8124163,97.0001097 L86.5624174,97.0001097 L51.8749505,152.000057 L51.8749505,153.250056 L87.8124163,153.250056 Z M234.687423,216.374996 C191.093715,216.296871 163.906241,185.046901 164.062491,132.312576 C164.218741,79.5001264 191.093715,49.8126547 234.687423,49.8126547 C278.203007,49.8126547 305.390481,79.6563762 305.312356,132.312576 C305.234231,185.281275 278.203007,216.453121 234.687423,216.374996 Z M234.687423,181.06253 C249.687409,181.06253 260.390524,165.984419 260.312399,132.312576 C260.234274,99.4219824 249.687409,84.8126213 234.687423,84.8126213 C219.687438,84.8126213 209.218698,99.4219824 209.062448,132.312576 C208.906198,165.984419 219.687438,181.06253 234.687423,181.06253 Z M324.062491,187.000024 L324.062491,153.250056 L388.43743,52.0001526 L443.437378,52.0001526 L443.437378,153.250056 L461.87486,153.250056 L461.87486,187.000024 L443.437378,187.000024 L443.437378,212 L401.874917,212 L401.874917,187.000024 L324.062491,187.000024 Z M402.812416,153.250056 L402.812416,97.0001097 L401.562417,97.0001097 L366.874951,152.000057 L366.874951,153.250056 L402.812416,153.250056 Z",
    id: 404
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.a71775fee75ddb38d53c2533e34cc81b.svg";
export { ForwardRef as ReactComponent };